import { Button } from '../components/Button.js';
import styles from './Callout.module.css';

interface CalloutProps {
  count: number;
  onReply: () => void;
  onLater: () => void;
}

/**
 * The nudge above the badge — the same count the launcher badge and the host
 * relay show (from the BFF while closed). "Reply" opens the panel to act on it.
 *
 * "Needs your reply" is honest wording because the count only ever includes
 * chats where someone else sent the last message (see `getPendingReplyCount`),
 * so there is always something to answer. An unread count could not promise
 * that — nor could it keep promising it after the employer read the message and
 * still owed an answer.
 */
export function Callout({ count, onReply, onLater }: CalloutProps) {
  return (
    <div className={styles.callout} role="status">
      <p className={styles.text}>
        <strong>{count}</strong> {count === 1 ? 'chat needs' : 'chats need'} your reply
      </p>
      <div className={styles.actions}>
        <Button onClick={onReply}>Reply</Button>
        <Button variant="ghost" onClick={onLater}>
          Later
        </Button>
      </div>
    </div>
  );
}
